var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { connect } from 'react-redux';

import Doc from "../Library/components/Doc";

import { RowList } from "./Lists";





class TilesViewerComponent extends React.Component {
  render() {
    return /*#__PURE__*/(
      _jsx(RowList, { zoomLevel: this.props.rowListZoomLevel }, void 0,
      this.props.documents.get('rows').map((doc) => /*#__PURE__*/
      _jsx(Doc, {
        doc: doc,
        storeKey: this.props.storeKey,

        onClick: this.props.clickOnDocument,
        onSnippetClick: this.props.onSnippetClick,
        deleteConnection: this.props.deleteConnection,
        searchParams: this.props.search }, doc === null || doc === void 0 ? void 0 : doc.get('_id')
      )
      )
      ));

  }
}

const mapStateToProps = (state, props) => ({
  documents: state[props.storeKey].documents,
  search: state[props.storeKey].search
});

export const TilesViewer = connect(mapStateToProps)(TilesViewerComponent);